<label for="inputtext">{{textField.typeChant}}</label>
<p-dropdown [options]="typeChantList" [(ngModel)]="objChant.typeChant" [formControl]="control" [itemSize]="10"
  [virtualScroll]="false" [filter]="false" [checkmark]="true" optionValue="value" optionLabel="name"
  styleClass="w100"  placeholder="{{textField.typeChant}}">
  <ng-template let-option  pTemplate="selectedItem">
    <div class="ofa" pTooltip="{{option.name}}" tooltipPosition="bottom">{{option.flag}} {{option.name}} </div>
  </ng-template>
  <ng-template let-option pTemplate="item">
    <span>{{option.flag}} {{option.name}} </span>
  </ng-template>
</p-dropdown>
